/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-destructuring */

import { Controller } from 'stimulus';

export default class extends Controller {
  initialize() {
    const currentUrl = window.location.href;
    const tabHash = currentUrl.split('#');
    this.smoothScroll();
    this.scrollToPosition();
  }

  smoothScroll() {
    const tabs = document.querySelectorAll('.tab-scroll');
    for (const t in tabs) {
      if (tabs.hasOwnProperty(t)) {
        tabs[t].addEventListener('click', (e) => {
          e.preventDefault();
          const offsetTop = document.querySelector(tabs[t].hash).offsetTop;
          scroll({
            top: offsetTop + 465,
            behavior: 'smooth',
          });
        });
      }
    }
  }

  scrollToPosition() {
    const sections = document.querySelectorAll('.section-position');
    window.onscroll = () => {
      const scrollPosition =
        (document.documentElement.scrollTop || document.body.scrollTop) - 200;

      for (const s in sections) {
        if (
          sections.hasOwnProperty(s) &&
          sections[s].offsetTop <= scrollPosition
        ) {
          const id = sections[s].id;
          if (document.getElementsByClassName('tab-active')[0]) {
            document
              .getElementsByClassName('tab-active')[0]
              .classList.remove('tab-active');
          }
          document
            .querySelector(`[id="id_${id}"]`)
            .parentNode.classList.add('tab-active');
        }
      }
    };
  }
}
